export const sharedImage = "/site.webp";
export const heroImage = "/jumbotron-mission-ready-split-0126.jpg";
export const categoryBanners = {
  military: "/cat-banner-military-2022.jpg",
  fire: "/cat-banner-fire-2022.jpg",
  hunting: "/cat-banner-hunting-mysterium.jpg",
  everyday: "/cat-banner-edc-2026.jpg",
  accessories: "/cat-banner-accessories-2026.jpg",
  logoWear: "/cat-banner-logowear-2026.jpg",
  topSellers: "/cat-banner-top-sellers-2026.jpg",
  collections: "/banner-block-everyday-favorites-0126.jpg",
  seasonalOffers: "/banner-block-top-sellers-fire-1225.jpg",
  stories: "/cat-banner-logowear-2026.jpg",
};

// Top-level nav with optional submenus. The mobile drawer pushes
// submenu rows into a second pane; the desktop header just renders the
// top-level labels for now.
export const navItems = [
  { label: "Military", path: "/military", children: [
    { label: "All Military", path: "/military" },
    { label: "Assault Packs", path: "/military#assault" },
    { label: "Medic", path: "/military#medic" },
    { label: "Frames + Accessories", path: "/military#frames" },
  ] },
  { label: "Fire", path: "/fire", children: [
    { label: "All Fire", path: "/fire" },
    { label: "Hand Crew", path: "/fire#crew" },
    { label: "Hotshot", path: "/fire#hotshot" },
    { label: "Initial Attack", path: "/fire#initial" },
  ] },
  { label: "Hunting", path: "/hunting", children: [
    { label: "All Hunting", path: "/hunting" },
    { label: "Day Hunt", path: "/hunting#day" },
    { label: "Backcountry", path: "/hunting#backcountry" },
    { label: "Mysterium", path: "/hunting#mysterium" },
  ] },
  { label: "Everyday Carry", path: "/everyday", children: [
    { label: "All EDC", path: "/everyday" },
    { label: "Daily Carry", path: "/everyday#daily" },
    { label: "Travel", path: "/everyday#travel" },
    { label: "Tech + Laptop", path: "/everyday#tech" },
  ] },
  { label: "Accessories", path: "/accessories" },
  { label: "Logo Wear", path: "/logo-wear" },
  { label: "Top Sellers", path: "/top-sellers" },
  { label: "Collections", path: "/collections" },
  { label: "Seasonal Offers", path: "/seasonal-offers" },
  { label: "Stories", path: "/stories" },
];

export const utilityItems = ["Search", "Cart"];

export const categories = [
  { title: "Hunting", cta: "Shop Hunting", image: "/home-square-hunting.jpg", path: "/hunting" },
  { title: "Fire", cta: "Shop Fire", image: "/home-square-fire.jpg", path: "/fire" },
  { title: "Military", cta: "Shop Military", image: "/home-square-military.jpg", path: "/military" },
  { title: "Everyday Carry", cta: "Shop EDC", image: "/home-square-everyday-2026.jpg", path: "/everyday" },
];

// "Best Sellers" cards on the home page. Each card now links to the
// matching category page; ProductCard wraps in <Link> when `path` is
// present.
export const products = [
  { name: "Assault Packs",  cta: "Shop Military",  image: "/banner-block-top-sellers-military-1225.jpg", path: "/military" },
  { name: "Everyday Carry", cta: "Shop EDC",       image: "/banner-block-everyday-favorites-0126.jpg",   path: "/everyday" },
  { name: "Hunting Packs",  cta: "Shop Hunting",   image: "/banner-block-top-sellers-hunt-1225.jpg",     path: "/hunting" },
  { name: "Fire",           cta: "Shop Fire",      image: "/banner-block-top-sellers-fire-1225.jpg",     path: "/fire" },
  { name: "Logo Wear",      cta: "Shop Logo Wear", image: "/banner-block-2026-logowear.jpg",             path: "/logo-wear" },
];
